/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Copy_PromptInputs */

const en_check_in_copy_prompt = /** @type {(inputs: Check_In_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy prompt`)
};

const es_check_in_copy_prompt = /** @type {(inputs: Check_In_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar prompt`)
};

/**
* | output |
* | --- |
* | "Copy prompt" |
*
* @param {Check_In_Copy_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_copy_prompt = /** @type {((inputs?: Check_In_Copy_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Copy_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_copy_prompt(inputs)
	return es_check_in_copy_prompt(inputs)
});